import { BasePayloadMapper } from '@ps/utils';
import {
  CompanySupplierSettingsDto,
  SupplierVariableMappingDto,
} from '../dtos/company-supplier-settings.dto';
import {
  SupplierSettingsForm,
  SupplierVariableMappingForm,
} from '../../models/company-form.model';
import {
  SUPPLIER_VARIABLE_MAPPING_ALWAYS_ON_KEYS,
  SUPPLIER_VARIABLE_MAPPING_DTO_KEYS,
  SUPPLIER_VARIABLE_MAPPING_OPTIONAL_KEYS,
} from '../supplier-variable-mapping.constants';

export class CompanySupplierSettingsPayloadMapper extends BasePayloadMapper<
  SupplierSettingsForm,
  Omit<CompanySupplierSettingsDto, 'cmp'>
> {
  public toPayload(
    form: SupplierSettingsForm,
  ): Omit<CompanySupplierSettingsDto, 'cmp'> {
    return {
      supplier_type: form.supplierType,
      dynamicProfiler: form.dynamicProfiler,
      isSegmentationEnabled: form.isSegmentationEnabled,
      isPrivacyPolicyActive: form.isPrivacyPolicyActive,
      cookieYesIntegration: form.cookieYesIntegration,
      hemsOnPixels: form.hemsOnPixels,
      isDataQualityQuestionsActive: form.isDataQualityQuestionsActive,
      isAsrRedirectionEnable: form.isAsrRedirectionEnable,
      skipPreScreener: form.skipPreScreener,
      isScreenerV2: form.isScreenerV2,
      isHashing: form.isHashing,
      isHashingInbound: form.isHashingInbound,
      private_key: form.privateKey,
      isNotify: form.isNotify,
      iss2sCallback: form.iss2sCallback,
      isCompleteToNonCompleteURL: form.isCompleteToNonCompleteURL,
      isNonCompleteToCompleteURL: form.isNonCompleteToCompleteURL,
      s2sMicroRewardCallbackURL: form.s2sMicroRewardCallbackURL,
      supp_url_completes: form.suppUrlCompletes,
      supp_url_overquota: form.suppUrlOverquota,
      supp_url_terms: form.suppUrlTerms,
      supp_url_security_terms: form.suppUrlSecurityTerms,
      microSurveySetting: {
        active: form.microSurveySetting.active,
        showConsent: form.microSurveySetting.showConsent,
        showMicrosurveySettings:
          form.microSurveySetting.showMicrosurveySettings,
        currencyName: form.microSurveySetting.currencyName,
        conversionValue: form.microSurveySetting.conversionValue ?? 0,
        rewardAmount: form.microSurveySetting.rewardAmount ?? 0,
      },
      variable_mapping: this._buildVariableMapping(form.variableMapping),
    };
  }

  private _buildVariableMapping(
    variableMapping: SupplierVariableMappingForm,
  ): SupplierVariableMappingDto[] {
    const alwaysOnEntries = SUPPLIER_VARIABLE_MAPPING_ALWAYS_ON_KEYS.map(
      (key): SupplierVariableMappingDto => ({
        [SUPPLIER_VARIABLE_MAPPING_DTO_KEYS[key]]: variableMapping[key],
      }),
    );

    const optionalEntries = SUPPLIER_VARIABLE_MAPPING_OPTIONAL_KEYS.filter(
      (key) => variableMapping[key].outgoing,
    ).map(
      (key): SupplierVariableMappingDto => ({
        [SUPPLIER_VARIABLE_MAPPING_DTO_KEYS[key]]: variableMapping[key],
      }),
    );

    return [...alwaysOnEntries, ...optionalEntries];
  }
}
